module.exports = __webpack_public_path__ + "static/forbes-38a4f95913cc91f5cfa5233c20f75224.svg";